"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PicolUtils = void 0;
class PicolUtils {
    static isPicolForbidCoin(coin) {
        // Test if the coin is in the forbidden list, and the pattern is like "XMR" or "XMR1L".
        const pattern = new RegExp(`^(${PicolUtils.PICOL_FORBID_COIN_LIST.join("|")})(\\d[A-Z])?$`, "i");
        return pattern.test(coin);
    }
    static isPicolForbidSymbol(symbol) {
        return PicolUtils.isPicolForbidCoin(symbol.baseDisplay) || PicolUtils.isPicolForbidCoin(symbol.quoteDisplay);
    }
}
exports.PicolUtils = PicolUtils;
PicolUtils.PICOL_FORBID_COIN_LIST = ["XMR", "DASH", "ZEC", "XVG"];
